import { Link } from "react-router-dom";
import { Mail, Instagram, Facebook } from "lucide-react";
import { BUSINESS_EMAIL, LOGO_LIGHT_URL } from "../data/site";

export const Footer = () => {
  return (
    <footer data-testid="footer" className="bg-[#1F2530] text-[#F3F4F6] border-t border-[#353B45]">
      <div className="max-w-7xl mx-auto px-6 sm:px-10 py-16">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8">
          <div>
            <h2 className="font-display text-4xl sm:text-5xl text-[#7BA7D9] leading-none">
              My Gifted Hands
            </h2>
            <p className="mt-4 max-w-md text-[#F3F4F6]/70 font-medium">
              Bold graphic design, illustration & commissioned art crafted with creativity, precision, and originality.
            </p>
          </div>
          <a
            data-testid="footer-email"
            href={`mailto:${BUSINESS_EMAIL}`}
            className="inline-flex items-center gap-3 brutal-border bg-[#3E6FA8] text-white font-extrabold uppercase tracking-wider px-6 py-4 brutal-press brutal-shadow-sm"
          >
            <Mail size={20} strokeWidth={2.5} /> {BUSINESS_EMAIL}
          </a>
        </div>

        <div className="mt-12 pt-6 border-t border-[#F3F4F6]/20 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-[#F3F4F6]/60">
            © {new Date().getFullYear()} My Gifted Hands. All rights reserved.
          </p>
          <div className="flex items-center gap-5">
            <Link to="/contact" data-testid="footer-contact-link" className="text-sm font-bold uppercase tracking-wide hover:text-[#E5E7EB]">
              Contact
            </Link>
            <Instagram size={20} className="hover:text-[#E5E7EB] cursor-pointer" />
            <Facebook size={20} className="hover:text-[#E5E7EB] cursor-pointer" />
          </div>
        </div>

        <div className="mt-14 flex justify-center" data-testid="footer-logo">
          <img
            src={LOGO_LIGHT_URL}
            alt="My Gifted Hands logo"
            className="h-44 sm:h-52 w-auto object-contain opacity-95"
          />
        </div>
      </div>
    </footer>
  );
};
